// src/components/RPA/buttons/FormulateAuditProceduresButton.js
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function FormulateAuditProceduresButton({ docId, onDone }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!docId) {
      console.error('[FORMULATE_PROCEDURES_BTN] ❌ No docId provided');
      return;
    }
    
    console.log('========== [FRONTEND] FORMULATE PROCEDURES REQUEST ==========');
    console.log('[FORMULATE_PROCEDURES_BTN] 📤 Sending request with docId:', docId);
    console.log('[FORMULATE_PROCEDURES_BTN] 📤 Request URL:', `${API_URL}/admin/rpa/docs/${docId}/formulate/audit-procedures`);
    console.log('[FORMULATE_PROCEDURES_BTN] 📤 Timestamp:', new Date().toISOString());
    console.log('============================================================');
    
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/formulate/audit-procedures`,
        {}, // No body needed since docId is in the URL params
        { withCredentials: true }
      );
      
      console.log('========== [FRONTEND] FORMULATE PROCEDURES SUCCESS ==========');
      console.log('[FORMULATE_PROCEDURES_BTN] ✅ Success response:', res.data);
      console.log('[FORMULATE_PROCEDURES_BTN] ✅ Response docId:', res.data.docId);
      console.log('[FORMULATE_PROCEDURES_BTN] ✅ Match:', res.data.docId === docId ? '✓ MATCH' : '✗ MISMATCH');
      console.log('=============================================================');
      
      if (onDone) onDone();
    } catch (err) {
      console.error('========== [FRONTEND] FORMULATE PROCEDURES ERROR ==========');
      console.error('[FORMULATE_PROCEDURES_BTN] ❌ Failed:', err);
      console.error('[FORMULATE_PROCEDURES_BTN] ❌ Response:', err.response?.data);
      console.error('===========================================================');
      alert(err.response?.data?.message || 'Audit procedures formulation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      style={{
        background: loading ? '#9ca3af' : '#8b5cf6',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 11,
        cursor: loading ? 'not-allowed' : 'pointer',
        fontWeight: 500
      }}
    >
      {loading ? 'Formulating…' : 'Formulate Procedures'}
    </button>
  );
}